import { uniq } from 'lodash-es';
import { normalize } from 'normalizr';
import { xhrStatusFactory } from 'redux/reusable/xhrStatus';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type { PinsState } from './pins.types';
import * as types from './pins.types';
import { pinsXhrModule } from './pins.types';

const { withXhrStatusReducer } = pinsXhrModule;

export const initialState: types.PinsState = {
  projectIds: [],
  reportEntities: {},
  reportResult: [],
  xhrStatus: xhrStatusFactory(),
};

const reducer = reducerWithInitialState<PinsState>(initialState)
  .caseWithAction(
    types.fetchedProjectPins,
    (state, action): PinsState => ({
      ...state,
      projectIds: action.payload.projects.map(p => p.id),
    })
  )
  .caseWithAction(types.toggleProjectPin, (state, action): PinsState => {
    const { projectId } = action.payload;
    const alreadyExists = state.projectIds.some(id => id === projectId);
    return {
      ...state,
      projectIds: alreadyExists
        ? state.projectIds.filter(id => id !== projectId)
        : [...state.projectIds, projectId],
    };
  })
  .case(types.fetchedReportsPins, (state, { reports }) => {
    const { entities, result } = normalize(reports, types.pinsListSchema);

    return {
      ...state,
      reportEntities: { ...state.reportEntities, ...entities.pins },
      reportResult: uniq([...state.reportResult, ...result]),
    };
  })
  .case(types.toggleReportPin, (state, report) => {
    const alreadyExists = !!state.reportEntities[report.id];
    const reportEntities = { ...state.reportEntities };
    if (alreadyExists) {
      delete reportEntities[report.id];
    } else {
      reportEntities[report.id] = report;
    }

    return {
      ...state,
      reportResult: alreadyExists
        ? state.reportResult.filter(id => id !== report.id)
        : [...state.reportResult, report.id],
      reportEntities,
    };
  });

export default withXhrStatusReducer(reducer);
